import { render, staticRenderFns } from "./BetAmounts.vue?vue&type=template&id=1f867e10&scoped=true&"
import script from "./BetAmounts.vue?vue&type=script&lang=js&"
export * from "./BetAmounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f867e10",
  null
  
)

export default component.exports